import type { SvgIconProps } from './types';

export function GiftBoxIcon(props: SvgIconProps) {
  return (
    <svg className="referral-gift-icon" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...props}>
            <circle cx="60" cy="60" r="54" className="referral-gift-bg" />
            <rect x="18" y="52" width="84" height="52" rx="8" className="referral-gift-box" strokeWidth="3" />
            <rect x="12" y="38" width="96" height="18" rx="6" className="referral-gift-lid" strokeWidth="3" />
            <path d="M60 38V104" className="referral-gift-stroke" strokeWidth="3" />
            <path d="M12 47H108" className="referral-gift-stroke" strokeWidth="3" />
            <path d="M60 38C60 24 48 18 40 24C32 30 40 38 60 38Z" className="referral-gift-bow" />
            <path d="M60 38C60 24 72 18 80 24C88 30 80 38 60 38Z" className="referral-gift-bow" />
        </svg>
  );
}
